import React from 'react';
import { Snackbar } from '../../../../common/components/Snackbar/Snackbar';
import { theme } from '../../../../common/styles/theme';
import { ISnackbarPanelProps } from './types';
import { Text } from '../../../../common/components/Text/Text';

export const SnackbarPanel: React.FC<ISnackbarPanelProps> = ({
  show,
  text,
  hideTimeSec,
  onClose
}) => {

  React.useEffect(() => {
    if (show && hideTimeSec > 0) {
      setTimeout(() => {
        onClose();
      }, hideTimeSec * 1000)
    }
  }, [show])

  if (!show) return null;
  return (
    <Snackbar
      open={true}
      hideClose={hideTimeSec > 0}
      onClose={onClose}
      sx={{
        width: theme.spacing(37.5),

        [theme.breakpoints.down('sm')]: {
          width: `calc(100% - ${theme.spacing(2)})`,
        },
      }}
    >
      {/* Plain text, not dangerouslySetInnerHTML: no message here carries markup, and some come
          from the server or the URL (see effects/authCallbackParams.ts). */}
      <Text
        sx={{ color: theme.palette.common.white, pr: theme.spacing(3) }}
        variant={'subtitle2'}
      >
        {text}
      </Text>

    </Snackbar>
  );
}
